import React from 'react';

const DesignGuidelines = () => {
  return <div>Design Guidelines</div>;
};

export default DesignGuidelines;
